jQuery(document).on('click', '.linkedin-packages-tab-button', function (event) {
    event.preventDefault()
    let button = jQuery(this),
        container = jQuery(`.${button.attr('id')}`)

    if (button.hasClass('active')) {
        return false
    }

    jQuery('.linkedin-packages-tab-button').not(button).removeClass('active')
    button.addClass('active')

    container.fadeIn('slow').addClass('show')
    jQuery('.linkedin-packages-tab-container').not(container).hide().removeClass('show')

    return false
})

jQuery(document).on('click', '.testimonials-tab-button', function (event) {
    event.preventDefault()
    let button = jQuery(this),
        container = jQuery(`.${button.attr('id')}`)

    if (button.hasClass('active')) {
        return false
    }

    jQuery('.testimonials-tab-button').not(button).removeClass('active')
    button.addClass('active')

    container.fadeIn('slow').addClass('show')
    jQuery('.testimonials-tab-container').not(container).hide().removeClass('show')

    return false
})

jQuery(document).ready(function () {
    jQuery(".expert_audit_form_wrapper_section").wrapAll(`<div class="fdc_section_expert_audit_form_container" />`);
    //jQuery( ".download_marketing_playbook_form_section" ).wrapAll( `<div class="fdc_download_marketing_playbook_form_container" />`);

    jQuery('.fdc_last_field').after(jQuery('.text_inside_form_download').detach());

    const firstLink = document.getElementsByClassName('agency-services-link');
    const firstImage = document.getElementsByClassName('fdc-services-image');
    if(firstLink.length) {
        firstLink[0].classList.add('active');
        firstImage[0].classList.add('show');
    }
    jQuery(document).on('mouseenter', '.agency-services-link', function (event) {
        let button = jQuery(this),
            containerClass = button.attr("id"),
            container = jQuery(`.${containerClass}`)
        if (button.hasClass('active')) {
            return false
        }

        jQuery('.agency-services-link').not(button).removeClass('active')
        button.addClass('active')

        // /**
        //  * Disable parallax scroll. It causes page jumping
        //  */
        // if (typeof window.scroller !== 'undefined') {
        //     scroller.kill()
        // }

        jQuery('.fdc-services-image').not(container).hide().removeClass('show')
        container.show().addClass('show')

    })


});

jQuery(document).on('click', 'body:not(.et-fb-root-ancestor) .sub-service-faq >div > div:first-of-type', function () {
    let button = jQuery(this),
        section = button.parent().parent()


    if (section.hasClass('open')) {
        section.find('>div>div:not(:first-of-type)').slideUp('fast', function () {
            section.removeClass('open')
        })


    } else {
        section.addClass('open').find('>div>div:not(:first-of-type)').css('display', 'none').slideDown('fast')
        /*jQuery([document.documentElement, document.body]).animate({
            scrollTop: section.offset().top - jQuery('#top-header').outerHeight() - (jQuery('#wpadminbar').outerHeight() ?? 0)
        }, 800);*/
    }
})
